angular
  .module('bb.appointments')
  .directive('phoneNumbersEditor', () => {
    return {
      restrict: 'E',
      scope: {
        phoneNumbers: '=',
        limit: '=',
        disabled: '=?',
        showError: '<',
      },
      controller() {
        this.addNumber = () => {
          this.phoneNumbers.push({});
        };
        this.removeNumber = indx => {
          this.phoneNumbers = this.phoneNumbers.filter(
            (_, index) => index != indx,
          );
        };
      },
      controllerAs: 'vm',
      bindToController: true,
      template: require('./appointment_phone_number_list.html'),
    };
  })
  .directive('phoneNumber', () => {
    return {
      restrict: 'E',
      scope: {
        phoneInfo: '=',
        hideSms: '=',
        hideMustCall: '=',
        hideType: '=',
        disabled: '=',
      },
      controller() {
        this.$onInit = function () {
          this.types = ['Primary', 'Mobile', 'Work', 'Home'];

          if (!this.phoneInfo.type) this.phoneInfo.type = 'Primary';
          this.phoneInfo.mustCall = !!this.phoneInfo.mustCall;
          this.phoneInfo.sendSms = !!this.phoneInfo.sendSms;
        };

        this.setType = type => {
          this.phoneInfo.type = type;
        };
      },
      controllerAs: 'vm',
      bindToController: true,
      template: require('./appointment_phone_number.html'),
    };
  });
